<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    侨香站<br>
站点介绍<br>
侨香站位于侨香路与农园路的交叉路口，斜穿侨香路和农园路，大致呈东西走向，呈南北走向布置。东侧有深圳住房公积金管理中心，西侧有深圳公安局经济犯罪侦察局、圆博园，南侧有荔园外国语小学、深圳高级中学、翠海花园幼儿园。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:26	00:06	2号线	2分35秒	5分45秒<br>
莲塘	06:03	23:34	2号线	2分35秒	5分45秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:31	00:05	2号线	4分钟	5分钟<br>
莲塘	06:03	23:34	2号线	4分钟	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:31	00:55	2号线	4分钟	5分钟<br>
莲塘	06:03	00:34	2号线	4分钟	5分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
侨香路西侧、深圳市眼科医院、深圳市公安局经济犯罪侦查局、国华大厦、鸿运阁、武警深圳市支队、中旅国际公馆<br><br>
B出入口:<br>
农园路、润田路、香域中央花园、深圳高级中学（集团）中心校区、荔园外国语小学（西校区）<br><br>
C出入口:<br>
深圳市住房公积金管理中心、深圳市福田区实验教育集团侨香学校 、翠海花园、侨香村、金地香蜜山国际公寓、香格丽苑、万科温馨家园、红岭中学（高中部）<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 翠海花园②<br>
104、316、323、M222、B729、B611<br><br>
B出入口:<br>
公交站名： 香域中央花园<br>
B729、M312、M398<br><br>
C出入口:<br>
公交站名： 翠海花园<br>
73、104、316、323、B611、B968、M222、M312、M398<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>